import React from "react";
import { Box } from "digiwash-components";

interface PropsType {
  ratio: string;
  children?: React.ReactNode;
}

function BoxRatio(props: PropsType) {
  let [w, h] = props.ratio.split(":");
  let width = 100; // percent
  let height = (h * 100) / w;

  return (
    <Box
      br="m"
      style={{
        width: `${width}%`,
        paddingTop: `${height}%`,
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box
        style={{
          width: "100%",
          height: "100%",
          position: "absolute",
          top: 0,
          left: 0,
        }}
      >
        {props.children}
      </Box>
    </Box>
  );
}

export default BoxRatio;
